export default __webpack_public_path__ + "static/media/opconfig.e895491e.svg";